import { path, prop } from 'ramda';

export const accessTokenSelector = path(['oidc', 'user', 'access_token']);

export const expiresAtSelector = path(['oidc', 'user', 'expires_at']);

export const oidcSelector = prop('oidc');

// export const userSelector = path(['oidcReducer', 'user']);

// export const expiringSelector = path(['userReducer', 'isExpiring']);
export const userLoggedSelector = path(['userReducer', 'userLogged']);



// WEBPACK FOOTER //
// ./src/selectors/oidcSelectors.js